import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import withWidth from '@material-ui/core/withWidth';
import GridViewDetailHeader from './Header';
import GridViewDetailItem from './Item';
import GridViewPagination from '../Pagination';
import GridViewNoData from '../NoData';
import LoadingBar from './LoadingBar';
import GridViewError from '../Error';
import { getItemId } from '../utils';
import responsive from './responsive';
import deepMerge from '../../../../utils/deepMerge';

var getSpecificConfig = function getSpecificConfig(config, propsConfig) {
  var cfg = config;

  if (config.view.mode) {
    cfg = deepMerge(config, {
      columns: config.columns.filter(function (c) {
        return c.modes ? c.modes.indexOf(config.view.mode) > -1 : true;
      })
    });
  }

  if (propsConfig) {
    cfg = deepMerge(config, propsConfig);
  }

  return cfg;
};

var useStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%'
  },
  rootNoElevation: {
    backgroundColor: 'transparent'
  },
  table: {
    fontSize: '9.5pt',
    tableLayout: 'fixed'
  },
  tableLayoutAuto: {
    tableLayout: 'auto'
  },
  hideBorder: {
    '& td': {
      border: 'none'
    }
  }
}, {
  name: 'ECGridViewDetails'
});
/**
 * @param {import('./types').DataGridViewDetailProps } props
 */

function GridViewDetails(_ref) {
  var _cx2;

  var width = _ref.width,
      config = _ref.config,
      onChangePage = _ref.onChangePage,
      onChangeItemsPerPage = _ref.onChangeItemsPerPage,
      onChangeSort = _ref.onChangeSort,
      onChangeFilter = _ref.onChangeFilter,
      onChangeMode = _ref.onChangeMode,
      onItemClick = _ref.onItemClick,
      onItemDoubleClick = _ref.onItemDoubleClick,
      rowComponent = _ref.rowComponent,
      rowComponentProps = _ref.rowComponentProps,
      styles = _ref.styles,
      hidePageSelector = _ref.hidePageSelector,
      hideItemsPerPage = _ref.hideItemsPerPage,
      hideModeSwitcher = _ref.hideModeSwitcher,
      paginationStyle = _ref.paginationStyle,
      style = _ref.style,
      className = _ref.className,
      isLoading = _ref.isLoading;
  var rest = {
    style: style,
    className: className
  };
  var classes = useStyles({});
  var ItemComponent = rowComponent || GridViewDetailItem;
  var cfgOverrides = {
    view: {}
  };
  if (typeof isLoading !== 'undefined') cfgOverrides.view.isLoading = isLoading;
  var cfg = getSpecificConfig(config, cfgOverrides);
  var paginationProps = {
    hidePageSelector: hidePageSelector,
    hideItemsPerPage: hideItemsPerPage,
    hideModeSwitcher: hideModeSwitcher,
    onChangeMode: onChangeMode,
    onChangeItemsPerPage: onChangeItemsPerPage,
    onChangePage: onChangePage,
    paginationStyle: paginationStyle
  };
  var columnsCount = responsive.getColumnsCount(cfg.columns, width);
  var showLoading = !!cfg.view.isLoading;
  if (typeof cfg.view.isLoading === 'number') showLoading = true;
  var firstColStyle = cfg.columns[0] ? cfg.columns[0].style : {};
  return React.createElement(Paper, Object.assign({
    classes: {
      root: cx(classes.root, _defineProperty({}, classes.rootNoElevation, styles.elevation === 0))
    },
    elevation: styles.elevation
  }, rest), showLoading && React.createElement(LoadingBar, {
    progress: cfg.view.isLoading,
    estimated: cfg.view.lastLoadingTook,
    startedAt: cfg.view.startedLoadingAt
  }), React.createElement(Table, {
    stickyHeader: true,
    className: cx((_cx2 = {}, _defineProperty(_cx2, classes.table, true), _defineProperty(_cx2, classes.tableLayoutAuto, styles.tableLayoutAuto), _defineProperty(_cx2, classes.hideBorder, styles.hideBorder), _cx2))
  }, React.createElement(GridViewDetailHeader, {
    width: width,
    filter: cfg.view.filter,
    sort: cfg.view.sort,
    by: cfg.view.by,
    columns: cfg.columns,
    onChangeSort: onChangeSort,
    onChangeFilter: onChangeFilter,
    isLoading: cfg.view.isLoading
  }), React.createElement(TableBody, null, cfg.data.map(function (item, rowIdx) {
    return React.createElement(ItemComponent, Object.assign({
      key: getItemId(item, cfg.idKeyProp, rowIdx),
      config: cfg,
      item: item,
      onClick: onItemClick,
      onDoubleClick: onItemDoubleClick,
      width: width
    }, rowComponentProps));
  }), !cfg.view.isLoading && !cfg.data.length && React.createElement(TableRow, null, React.createElement(TableCell, {
    colSpan: columnsCount,
    style: firstColStyle
  }, cfg.view.error ? React.createElement(GridViewError, {
    error: cfg.view.error
  }) : React.createElement(GridViewNoData, null)))), React.createElement(TableFooter, null, React.createElement(TableRow, null, React.createElement(TableCell, {
    colSpan: columnsCount,
    padding: "none",
    variant: "body"
  }, React.createElement(GridViewPagination, Object.assign({
    page: cfg.view.page,
    itemsPerPage: cfg.view.itemsPerPage,
    count: cfg.count,
    mode: cfg.view.mode
  }, paginationProps, {
    indent: firstColStyle && (firstColStyle.paddingLeft || firstColStyle.marginLeft)
  })))))));
}

GridViewDetails.defaultProps = {
  rowComponentProps: {}
};
export default withWidth()(GridViewDetails);